import React from 'react';
import { string } from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import Logo3dots from '../../../public/images/Home-3dots.svg';
import s from './style.css';

const Logo = ({ className, logoUrl }) => (
  <div className={cx(s.container, className)}>
    <img src={logoUrl} alt="3dots" className={s.logo} />
  </div>
);

Logo.propTypes = {
  className: string,
  logoUrl: string,
};

Logo.defaultProps = {
  className: 'container',
  logoUrl: Logo3dots,
};

export default withStyles(s)(Logo);
